import work1 from "../../assets/images/work-1.jpg";
import work2 from "../../assets/images/work-2.jpg";
import work3 from "../../assets/images/work-3.jpg";
import work4 from "../../assets/images/work-4.jpg";

const Work = () => {
  return (
    <section className="work pt-10 pb-8 bg-dark text-center text-white rounded3 rounded-start-0 position-relative">
      <div className="overlay rounded3 rounded-start-0"></div>

      <div className="container position-relative">
        <div className="work-inner">

          {/* SECTION TITLE */}
          <div className="section-title mb-8">
            <h6 className="text-uppercase fw-medium text-white mb-1">
              How we work
            </h6>
            <h2 className="text-white">
              Professional <span className="green">EV Charging</span> solution for you
            </h2>
          </div>

          {/* SECTION BODY */}
          <div className="section-body">
            <div className="row gy-5 gx-md-5">

              {[
                {
                  img: work1,
                  title: "Site Feasibility Study",
                  number: "01.",
                  detail:"Conducting detailed technical site assessments and feasibility checks.",
                },
                {
                  img: work2,
                  title: "Infrastructure Construction",
                  number: "02.",
                  extraClass: "my-8",
                  detail:"Complete civil and electrical building of charging station hubs.",
                },
                {
                  img: work3,
                  title: "Electrical & Grid Connectivity",
                  number: "03.",
                  detail:"Establishing expert LT/HT connections and meter changing.",
                },
                {
                  img: work4,
                  title: "Site Commissioning",
                  number: "04.",
                  extraClass: "my-8",
                  detail:"Final end-to-end testing and professional site activation.",
                },
              ].map((item, index) => (
                <div className="col-xl-3 col-md-6" key={index}>
                  <div className={`work-box position-relative ${item.extraClass || ""}`}>

                    <div className="work-image mb-5">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="rounded-circle object-fit-cover"
                      />
                    </div>

                    <div className="work-info">
                      <h4 className="mb-3 text-white">{item.title}</h4>
                      <p>
                        {item.detail}
                      </p>
                    </div>

                    <div className="work-box-number rounded-circle border border-3 border-lightgreen bg-green position-absolute">
                      <h4 className="text-white">{item.number}</h4>
                    </div>

                  </div>
                </div>
              ))}

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Work;
